/* global DocumentTouch */
/**
 * Checks to see if TouchEvents are valid for Mobile items.
 * @return {boolean} - can the device support touch events.
 */
let isEnabled = null;
export function isTouchEnabled() {
    if (isEnabled === null) {
        if (window && ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch)) {
            isEnabled = true;
        }
        else {
            isEnabled = false;
        }
    }
    return isEnabled;
}
